<template>
    <div>
        <b-alert show variant="secondary">
            <b-row :align-h="align">

                <b-col cols="12" md="8" v-if="showIcon" class="text-center">
                    <div class="inbox">
                        <img class="agri-icon" :src="$config.getAssetsURL(agriImg)" alt="no Data" />
                        <i class="fa fa-question faa-shake animated question"></i>
                        <i class="fa fa-inbox box"></i>
                    </div>
                    <div class="inbox-info">
                        <span v-if="showInfo">{{ showInfo }}</span>
                        <span v-else>{{ $t('menu.no_data') }}</span>
                    </div>
                </b-col>

                <b-col cols="12" md="12" v-else>
                    <div class="inbox-info-only-text">
                        <i class="fa fa-minus-circle block-text"></i>
                        <span v-if="showInfo">{{ showInfo }}</span>
                        <span v-else>{{ $t('menu.no_data') }}</span>
                    </div>
                </b-col>

            </b-row>
        </b-alert>
    </div>
</template>

<script>
export default {
    props: {
        showIcon: {
            type: Boolean,
            default: true,
        },
        showInfo: {
            type: String,
            default: undefined,
        },
        align: {
            type: String,
            default: 'center',
        },
    },
    data () {
        return {
            agriImg: 'img/brand/AgriOpenMouth.png',
        }
    },
}
</script>

<style lang="scss" scoped>

$img_opacity: 0.5;
$icon_opacity: 0.7;

.inbox
{
    display: inline-block;
}
.inbox-info
{
    display: inline-block;
    vertical-align: middle;
    margin-left: 15px;
    margin-top: 3px;
    font-size: 1.4rem;
    text-align: center;
}
.inbox-info-only-text
{
    font-size: 1.2rem;
    text-align: center;
}

.agri-icon
{
    width: 50px;
    opacity: $img_opacity;
    filter: alpha( opacity = $img_opacity * 100 ); /* For IE8 and earlier */
}

.question
{
    vertical-align: top;
    font-size: 1.5rem;
    margin: 0px 5px 2px 3px;
    color: #a9a9a9;
}

.box
{
    vertical-align: top;
    font-size: 2.5rem;
    margin-top: 3px;
    opacity: $icon_opacity;
    filter: alpha( opacity = $icon_opacity * 100 ); /* For IE8 and earlier */
}

</style>

